var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row print-flex"},[_c('div',{staticClass:"span3 nbsp"},[_vm._v(" ")]),_c('div',{staticClass:"span9 print-flex"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }